import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { apiConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data?.responseData?.transactions
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const getDMRTransactions = (tokens: any, reqBody: any) => {
  const config = apiConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.dmrTransactions,
    method: 'POST',
    config,
    body: reqBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}

export const getDmtTransactionsRequest = (mobile: string, agentId: string, remitterMobileNo: any) => {
  return {
    mobile,
    agentId,
    remitterMobileNo,
  }
}
